import script from "./HomePageCard.vue?vue&type=script&setup=true&lang=js"
export * from "./HomePageCard.vue?vue&type=script&setup=true&lang=js"

import "./HomePageCard.vue?vue&type=style&index=0&id=2a4809b8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a4809b8"]])

export default __exports__